import { DataCycle } from './../containers/data-cycles/data-cycles.interface'
import { FinancialInstitution } from './../containers/financial-institutions/financial-institutions.interface'
import { Organization } from './../containers/organizations/organizations.interface'
import { Community } from './../containers/communities/communities.interface'
import { Action } from '@ngrx/store'
import * as SharedTypes from './shared.types'
import { Street } from '../containers/streets/streets.interface'
import { Ward } from '@containers/wards/wards.interface'

export class ShowSnackbar implements Action {
  readonly type = SharedTypes.SHOW_SNACKBAR
  constructor(public payload: any) {}
}

export class FetchImageTypesRequest implements Action {
  readonly type = SharedTypes.FETCH_IMAGE_TYPES_REQUEST
  constructor(public model: 'property' | 'business') {}
}

export class FetchImageTypesSuccess implements Action {
  readonly type = SharedTypes.FETCH_IMAGE_TYPES_SUCCESS
  constructor(public payload: Street[]) {}
}

export class FetchImageTypesFailure implements Action {
  readonly type = SharedTypes.FETCH_IMAGE_TYPES_FAILURE
  constructor(public payload: any) {}
}

export class SearchStreetsRequest implements Action {
  readonly type = SharedTypes.SEARCH_STREETS_REQUEST
  constructor(public keyword: string) {}
}

export class SearchStreetsSuccess implements Action {
  readonly type = SharedTypes.SEARCH_STREETS_SUCCESS
  constructor(public payload: Street[]) {}
}

export class SearchStreetsFailure implements Action {
  readonly type = SharedTypes.SEARCH_STREETS_FAILURE
  constructor(public payload: any) {}
}

export class SearchGisStreetsRequest implements Action {
  readonly type = SharedTypes.SEARCH_GIS_STREETS_REQUEST
  constructor(public keyword: string) {}
}

export class SearchGisStreetsSuccess implements Action {
  readonly type = SharedTypes.SEARCH_GIS_STREETS_SUCCESS
  constructor(public payload: Street[]) {}
}

export class SearchGisStreetsFailure implements Action {
  readonly type = SharedTypes.SEARCH_GIS_STREETS_FAILURE
  constructor(public payload: any) {}
}

export class SearchCommunitiesRequest implements Action {
  readonly type = SharedTypes.SEARCH_COMMUNITIES_REQUEST
  constructor(public keyword: string) {}
}

export class SearchCommunitiesSuccess implements Action {
  readonly type = SharedTypes.SEARCH_COMMUNITIES_SUCCESS
  constructor(public payload: Community[]) {}
}

export class SearchCommunitiesFailure implements Action {
  readonly type = SharedTypes.SEARCH_COMMUNITIES_FAILURE
  constructor(public payload: any) {}
}

export class SearchContactTitlesRequest implements Action {
  readonly type = SharedTypes.SEARCH_CONTACT_TITLES_REQUEST
  constructor(public keyword: string) {}
}

export class SearchContactTitlesSuccess implements Action {
  readonly type = SharedTypes.SEARCH_CONTACT_TITLES_SUCCESS
  constructor(public payload: Community[]) {}
}

export class SearchContactTitlesFailure implements Action {
  readonly type = SharedTypes.SEARCH_CONTACT_TITLES_FAILURE
  constructor(public payload: any) {}
}

export class SearchPaymentPurposesRequest implements Action {
  readonly type = SharedTypes.SEARCH_PAYMENT_PURPOSES_REQUEST
  constructor(public keyword: string) {}
}

export class SearchPaymentPurposesSuccess implements Action {
  readonly type = SharedTypes.SEARCH_PAYMENT_PURPOSES_SUCCESS
  constructor(public payload: any[]) {}
}

export class SearchPaymentPurposesFailure implements Action {
  readonly type = SharedTypes.SEARCH_PAYMENT_PURPOSES_FAILURE
  constructor(public payload: any) {}
}

export class SearchContactTypesRequest implements Action {
  readonly type = SharedTypes.SEARCH_CONTACT_TYPES_REQUEST
  constructor(public keyword: string) {}
}

export class SearchContactTypesSuccess implements Action {
  readonly type = SharedTypes.SEARCH_CONTACT_TYPES_SUCCESS
  constructor(public payload: Community[]) {}
}

export class SearchContactTypesFailure implements Action {
  readonly type = SharedTypes.SEARCH_CONTACT_TYPES_FAILURE
  constructor(public payload: any) {}
}

export class SearchOrganizationRequest implements Action {
  readonly type = SharedTypes.SEARCH_ORGANIZATION_REQUEST
  constructor(public keyword: string) {}
}

export class SearchOrganizationSuccess implements Action {
  readonly type = SharedTypes.SEARCH_ORGANIZATION_SUCCESS
  constructor(public payload: Organization[]) {}
}

export class SearchOrganizationFailure implements Action {
  readonly type = SharedTypes.SEARCH_ORGANIZATION_FAILURE
  constructor(public payload: any) {}
}

export class FetchOrganizationsRequest implements Action {
  readonly type = SharedTypes.FETCH_ORGANIZATIONS_REQUEST
  constructor(public payload: any) {}
}

export class FetchOrganizationsSuccess implements Action {
  readonly type = SharedTypes.FETCH_ORGANIZATIONS_SUCCESS
  constructor(public payload: Organization[]) {}
}

export class FetchOrganizationsFailure implements Action {
  readonly type = SharedTypes.FETCH_ORGANIZATIONS_FAILURE
  constructor(public payload: any) {}
}

export class SearchIndustryRequest implements Action {
  readonly type = SharedTypes.SEARCH_INDUSTRY_REQUEST
  constructor(public keyword: string) {}
}

export class SearchIndustrySuccess implements Action {
  readonly type = SharedTypes.SEARCH_INDUSTRY_SUCCESS
  constructor(public payload: Organization[]) {}
}

export class SearchIndustryFailure implements Action {
  readonly type = SharedTypes.SEARCH_INDUSTRY_FAILURE
  constructor(public payload: any) {}
}

export class SearchFinancialInstitutionRequest implements Action {
  readonly type = SharedTypes.SEARCH_FINANCIAL_INSTITUTION_REQUEST
  constructor(public keyword: string) {}
}

export class SearchFinancialInstitutionSuccess implements Action {
  readonly type = SharedTypes.SEARCH_FINANCIAL_INSTITUTION_SUCCESS
  constructor(public payload: FinancialInstitution[]) {}
}

export class SearchFinancialInstitutionFailure implements Action {
  readonly type = SharedTypes.SEARCH_FINANCIAL_INSTITUTION_FAILURE
  constructor(public payload: any) {}
}

export class FetchSwitchableDataCyclesRequest implements Action {
  readonly type = SharedTypes.FETCH_SWITCHABLE_DATA_CYCLES_REQUEST
  constructor() {}
}

export class FetchSwitchableDataCyclesSuccess implements Action {
  readonly type = SharedTypes.FETCH_SWITCHABLE_DATA_CYCLES_SUCCESS
  constructor(public payload: DataCycle[]) {}
}

export class FetchSwitchableDataCyclesFailure implements Action {
  readonly type = SharedTypes.FETCH_SWITCHABLE_DATA_CYCLES_FAILURE
  constructor(public payload: any) {}
}

export class FetchRoundFactorsRequest implements Action {
  readonly type = SharedTypes.FETCH_ROUND_FACTORS_REQUEST
  constructor() {}
}

export class FetchRoundFactorsSuccess implements Action {
  readonly type = SharedTypes.FETCH_ROUND_FACTORS_SUCCESS
  constructor(public payload: DataCycle[]) {}
}

export class FetchRoundFactorsFailure implements Action {
  readonly type = SharedTypes.FETCH_ROUND_FACTORS_FAILURE
  constructor(public payload: any) {}
}

export class SearchWardsRequest implements Action {
  readonly type = SharedTypes.SEARCH_WARDS_REQUEST
  constructor(public keyword: string) {}
}

export class SearchWardsSuccess implements Action {
  readonly type = SharedTypes.SEARCH_WARDS_SUCCESS
  constructor(public payload: FinancialInstitution[]) {}
}

export class SearchWardsFailure implements Action {
  readonly type = SharedTypes.SEARCH_WARDS_FAILURE
  constructor(public payload: any) {}
}

export class DetectWardByCoordinateRequest implements Action {
  readonly type = SharedTypes.DETECT_WARD_BY_COORDINATE_REQUEST
  constructor(public coordinate: any[]) {}
}

export class DetectWardByCoordinateSuccess implements Action {
  readonly type = SharedTypes.DETECT_WARD_BY_COORDINATE_SUCCESS
  constructor(public payload: Ward[]) {}
}

export class DetectWardByCoordinateFailure implements Action {
  readonly type = SharedTypes.DETECT_WARD_BY_COORDINATE_FAILURE
  constructor(public payload: any) {}
}

export class FetchSearchTypesRequest implements Action {
  readonly type = SharedTypes.FETCH_SEARCH_TYPES_REQUEST
  constructor() {}
}

export class FetchSearchTypesSuccess implements Action {
  readonly type = SharedTypes.FETCH_SEARCH_TYPES_SUCCESS
  constructor(public payload: FinancialInstitution[]) {}
}

export class FetchSearchTypesFailure implements Action {
  readonly type = SharedTypes.FETCH_SEARCH_TYPES_FAILURE
  constructor(public payload: any) {}
}

export class FetchWardsRequest implements Action {
  readonly type = SharedTypes.FETCH_WARDS_REQUEST
  constructor() {}
}

export class FetchWardsSuccess implements Action {
  readonly type = SharedTypes.FETCH_WARDS_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchWardsFailure implements Action {
  readonly type = SharedTypes.FETCH_WARDS_FAILURE
  constructor(public payload: any) {}
}

export class FetchDiscountGroupsRequest implements Action {
  readonly type = SharedTypes.FETCH_DISCOUNT_GROUPS_REQUEST
  constructor() {}
}

export class FetchDiscountGroupsSuccess implements Action {
  readonly type = SharedTypes.FETCH_DISCOUNT_GROUPS_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchDiscountGroupsFailure implements Action {
  readonly type = SharedTypes.FETCH_DISCOUNT_GROUPS_FAILURE
  constructor(public payload: any) {}
}

export class FetchAssessableTypesRequest implements Action {
  readonly type = SharedTypes.FETCH_ASSESSABLE_TYPES_REQUEST
  constructor() {}
}

export class FetchAssessableTypesSuccess implements Action {
  readonly type = SharedTypes.FETCH_ASSESSABLE_TYPES_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchAssessableTypesFailure implements Action {
  readonly type = SharedTypes.FETCH_ASSESSABLE_TYPES_FAILURE
  constructor(public payload: any) {}
}

export class FetchPropertyStatusesRequest implements Action {
  readonly type = SharedTypes.FETCH_PROPERTY_STATUSES_REQUEST
  constructor() {}
}

export class FetchPropertyStatusesSuccess implements Action {
  readonly type = SharedTypes.FETCH_PROPERTY_STATUSES_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchPropertyStatusesFailure implements Action {
  readonly type = SharedTypes.FETCH_PROPERTY_STATUSES_FAILURE
  constructor(public payload: any) {}
}

export class FetchBusinessSubcategoryTypeRequest implements Action {
  readonly type = SharedTypes.FETCH_BUSINESS_SUBCATEGORY_TYPE_REQUEST
  constructor() {}
}

export class FetchBusinessSubcategoryTypeSuccess implements Action {
  readonly type = SharedTypes.FETCH_BUSINESS_SUBCATEGORY_TYPE_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchBusinessSubcategoryTypeFailure implements Action {
  readonly type = SharedTypes.FETCH_BUSINESS_SUBCATEGORY_TYPE_FAILURE
  constructor(public payload: any) {}
}

export class FetchBusinessSubcategoryCalculationTypeRequest implements Action {
  readonly type =
    SharedTypes.FETCH_BUSINESS_SUBCATEGORY_CALCULATION_TYPE_REQUEST
  constructor() {}
}

export class FetchBusinessSubcategoryCalculationTypeSuccess implements Action {
  readonly type =
    SharedTypes.FETCH_BUSINESS_SUBCATEGORY_CALCULATION_TYPE_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchBusinessSubcategoryCalculationTypeFailure implements Action {
  readonly type =
    SharedTypes.FETCH_BUSINESS_SUBCATEGORY_CALCULATION_TYPE_FAILURE
  constructor(public payload: any) {}
}

export class ExportListDataRequest implements Action {
  readonly type = SharedTypes.EXPORT_LIST_DATA_REQUEST
  constructor(public payload: any) {}
}

export class ExportListDataSuccess implements Action {
  readonly type = SharedTypes.EXPORT_LIST_DATA_SUCCESS
  constructor(public blob: Blob, public payload: any) {}
}

export class ExportListDataFailure implements Action {
  readonly type = SharedTypes.EXPORT_LIST_DATA_FAILURE
  constructor(public payload: any) {}
}

export class FetchActiveLayersRequest implements Action {
  readonly type = SharedTypes.FETCH_ACTIVE_LAYERS_REQUEST
  constructor(public payload?: any) {}
}

export class FetchActiveLayersSuccess implements Action {
  readonly type = SharedTypes.FETCH_ACTIVE_LAYERS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchActiveLayersFailure implements Action {
  readonly type = SharedTypes.FETCH_ACTIVE_LAYERS_FAILURE
  constructor(public payload: any) {}
}

export class FetchLayerFeaturesRequest implements Action {
  readonly type = SharedTypes.FETCH_LAYER_FEATURES_REQUEST
  constructor(public payload?: any) {}
}

export class FetchLayerFeaturesSuccess implements Action {
  readonly type = SharedTypes.FETCH_LAYER_FEATURES_SUCCESS
  constructor(public payload: any) {}
}

export class FetchLayerFeaturesFailure implements Action {
  readonly type = SharedTypes.FETCH_LAYER_FEATURES_FAILURE
  constructor(public payload: any) {}
}

export class DetectLayerRequest implements Action {
  readonly type = SharedTypes.DETECT_LAYER_REQUEST
  constructor(public payload: any) {}
}

export class DetectLayerSuccess implements Action {
  readonly type = SharedTypes.DETECT_LAYER_SUCCESS
  constructor(public payload: any) {}
}

export class DetectLayerFailure implements Action {
  readonly type = SharedTypes.DETECT_LAYER_FAILURE
  constructor(public payload: any) {}
}

export class DetectAllLayersRequest implements Action {
  readonly type = SharedTypes.DETECT_ALL_LAYERS_REQUEST
  constructor(public payload: any) {}
}

export class DetectAllLayersSuccess implements Action {
  readonly type = SharedTypes.DETECT_ALL_LAYERS_SUCCESS
  constructor(public payload: any) {}
}

export class DetectAllLayersFailure implements Action {
  readonly type = SharedTypes.DETECT_ALL_LAYERS_FAILURE
  constructor(public payload: any) {}
}

export class FetchBusinessCategoriesRequest implements Action {
  readonly type = SharedTypes.FETCH_BUSINESS_CATEGORIES_REQUEST
  constructor(public payload: any) {}
}

export class FetchBusinessCategoriesSuccess implements Action {
  readonly type = SharedTypes.FETCH_BUSINESS_CATEGORIES_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchBusinessCategoriesFailure implements Action {
  readonly type = SharedTypes.FETCH_BUSINESS_CATEGORIES_FAILURE
  constructor(public payload: any) {}
}

export class FetchContactsRequest implements Action {
  readonly type = SharedTypes.FETCH_CONTACTS_REQUEST
  constructor(public payload: any) {}
}

export class FetchContactsSuccess implements Action {
  readonly type = SharedTypes.FETCH_CONTACTS_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchContactsFailure implements Action {
  readonly type = SharedTypes.FETCH_CONTACTS_FAILURE
  constructor(public payload: any) {}
}

export class FetchContactTitlesRequest implements Action {
  readonly type = SharedTypes.FETCH_CONTACT_TITLES_REQUEST
  constructor(public payload: any) {}
}

export class FetchContactTitlesSuccess implements Action {
  readonly type = SharedTypes.FETCH_CONTACT_TITLES_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchContactTitlesFailure implements Action {
  readonly type = SharedTypes.FETCH_CONTACT_TITLES_FAILURE
  constructor(public payload: any) {}
}

export class FetchFormsRequest implements Action {
  readonly type = SharedTypes.FETCH_FORMS_REQUEST
  constructor() {}
}

export class FetchFormsSuccess implements Action {
  readonly type = SharedTypes.FETCH_FORMS_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchFormsFailure implements Action {
  readonly type = SharedTypes.FETCH_FORMS_FAILURE
  constructor(public payload: any) {}
}

export class FetchStaticTemplateRequest implements Action {
  readonly type = SharedTypes.FETCH_STATIC_TEMPLATE_REQUEST
  constructor(public key: string, public lang: string) {}
}

export class FetchStaticTemplateSuccess implements Action {
  readonly type = SharedTypes.FETCH_STATIC_TEMPLATE_SUCCESS
  constructor(public payload: any) {}
}

export class FetchStaticTemplateFailure implements Action {
  readonly type = SharedTypes.FETCH_STATIC_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

export class AcceptTermsOfServiceRequest implements Action {
  readonly type = SharedTypes.ACCEPT_TERMS_OF_SERVICE_REQUEST
  constructor() {}
}

export class AcceptTermsOfServiceSuccess implements Action {
  readonly type = SharedTypes.ACCEPT_TERMS_OF_SERVICE_SUCCESS
  constructor(public payload: any) {}
}

export class AcceptTermsOfServiceFailure implements Action {
  readonly type = SharedTypes.ACCEPT_TERMS_OF_SERVICE_FAILURE
  constructor(public payload: any) {}
}

export class FetchMobileTaskTypesRequest implements Action {
  readonly type = SharedTypes.FETCH_MOBILE_TASK_TYPES_REQUEST
  constructor() {}
}

export class FetchMobileTaskTypesSuccess implements Action {
  readonly type = SharedTypes.FETCH_MOBILE_TASK_TYPES_SUCCESS
  constructor(public payload: any) {}
}

export class FetchMobileTaskTypesFailure implements Action {
  readonly type = SharedTypes.FETCH_MOBILE_TASK_TYPES_FAILURE
  constructor(public payload: any) {}
}

export class FetchTemplateTypesRequest implements Action {
  readonly type = SharedTypes.FETCH_TEMPLATE_TYPES_REQUEST
  constructor() {}
}

export class FetchTemplateTypesSuccess implements Action {
  readonly type = SharedTypes.FETCH_TEMPLATE_TYPES_SUCCESS
  constructor(public payload: any) {}
}

export class FetchTemplateTypesFailure implements Action {
  readonly type = SharedTypes.FETCH_TEMPLATE_TYPES_FAILURE
  constructor(public payload: any) {}
}

export class FetchAuditLogTypesRequest implements Action {
  readonly type = SharedTypes.FETCH_AUDIT_LOG_TYPES_REQUEST
  constructor() {}
}

export class FetchAuditLogTypesSuccess implements Action {
  readonly type = SharedTypes.FETCH_AUDIT_LOG_TYPES_SUCCESS
  constructor(public payload: any) {}
}

export class FetchAuditLogTypesFailure implements Action {
  readonly type = SharedTypes.FETCH_AUDIT_LOG_TYPES_FAILURE
  constructor(public payload: any) {}
}

export class SetDefaultData implements Action {
  readonly type = SharedTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export class FetchAreaRoundingRequest implements Action {
  readonly type = SharedTypes.FETCH_AREA_ROUNDING_REQUEST
  constructor() {}
}

export class FetchAreaRoundingSuccess implements Action {
  readonly type = SharedTypes.FETCH_AREA_ROUNDING_SUCCESS
  constructor(public payload: DataCycle[]) {}
}

export class FetchAreaRoundingFailure implements Action {
  readonly type = SharedTypes.FETCH_AREA_ROUNDING_FAILURE
  constructor(public payload: any) {}
}

export class FetchPropertyTypesByCodeRequest implements Action {
  readonly type = SharedTypes.FETCH_PROPERTY_TYPES_BY_CODE_REQUEST
  constructor(public code: string) {}
}

export class FetchPropertyTypesByCodeSuccess implements Action {
  readonly type = SharedTypes.FETCH_PROPERTY_TYPES_BY_CODE_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchPropertyTypesByCodeFailure implements Action {
  readonly type = SharedTypes.FETCH_PROPERTY_TYPES_BY_CODE_FAILURE
  constructor(public payload: any) {}
}

export class FetchLicenseTypesRequest implements Action {
  readonly type = SharedTypes.FETCH_LICENSE_TYPES_REQUEST
  constructor() {}
}

export class FetchLicenseTypesSuccess implements Action {
  readonly type = SharedTypes.FETCH_LICENSE_TYPES_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchLicenseTypesFailure implements Action {
  readonly type = SharedTypes.FETCH_LICENSE_TYPES_FAILURE
  constructor(public payload: any) {}
}

export class FetchPropertyTypesRequest implements Action {
  readonly type = SharedTypes.FETCH_PROPERTY_TYPES_REQUEST
  constructor(public id: any) {}
}

export class FetchPropertyTypesSuccess implements Action {
  readonly type = SharedTypes.FETCH_PROPERTY_TYPES_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchPropertyTypesFailure implements Action {
  readonly type = SharedTypes.FETCH_PROPERTY_TYPES_FAILURE
  constructor(public payload: any) {}
}

export class FetchMobileUserModesRequest implements Action {
  readonly type = SharedTypes.FETCH_MOBILE_USER_MODES_REQUEST
  constructor() {}
}

export class FetchMobileUserModesSuccess implements Action {
  readonly type = SharedTypes.FETCH_MOBILE_USER_MODES_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchMobileUserModesFailure implements Action {
  readonly type = SharedTypes.FETCH_MOBILE_USER_MODES_FAILURE
  constructor(public payload: any) {}
}

export class FetchPostprocessorSlotTypesRequest implements Action {
  readonly type = SharedTypes.FETCH_POSTPROCESSOR_SLOT_TYPES_REQUEST
  constructor() {}
}

export class FetchPostprocessorSlotTypesSuccess implements Action {
  readonly type = SharedTypes.FETCH_POSTPROCESSOR_SLOT_TYPES_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchPostprocessorSlotTypesFailure implements Action {
  readonly type = SharedTypes.FETCH_POSTPROCESSOR_SLOT_TYPES_FAILURE
  constructor(public payload: any) {}
}

export class FetchDocumentTypesRequest implements Action {
  readonly type = SharedTypes.FETCH_DOCUMENT_TYPES_REQUEST
  constructor() {}
}

export class FetchDocumentTypesSuccess implements Action {
  readonly type = SharedTypes.FETCH_DOCUMENT_TYPES_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchDocumentTypesFailure implements Action {
  readonly type = SharedTypes.FETCH_DOCUMENT_TYPES_FAILURE
  constructor(public payload: any) {}
}

export type Actions =
  | ShowSnackbar
  | SearchStreetsRequest
  | SearchStreetsSuccess
  | SearchStreetsFailure
  | SearchCommunitiesRequest
  | SearchCommunitiesSuccess
  | SearchCommunitiesFailure
  | SearchContactTitlesRequest
  | SearchContactTitlesSuccess
  | SearchContactTitlesFailure
  | SearchContactTypesRequest
  | SearchContactTypesSuccess
  | SearchContactTypesFailure
  | SearchOrganizationRequest
  | SearchOrganizationSuccess
  | SearchOrganizationFailure
  | SearchIndustryRequest
  | SearchIndustrySuccess
  | SearchIndustryFailure
  | FetchImageTypesRequest
  | FetchImageTypesSuccess
  | FetchImageTypesFailure
  | SearchPaymentPurposesRequest
  | SearchPaymentPurposesSuccess
  | SearchPaymentPurposesFailure
  | SearchGisStreetsRequest
  | SearchGisStreetsSuccess
  | SearchGisStreetsFailure
  | SearchFinancialInstitutionRequest
  | SearchFinancialInstitutionSuccess
  | SearchFinancialInstitutionFailure
  | FetchSwitchableDataCyclesRequest
  | FetchSwitchableDataCyclesSuccess
  | FetchSwitchableDataCyclesFailure
  | FetchRoundFactorsRequest
  | FetchRoundFactorsSuccess
  | FetchRoundFactorsFailure
  | SearchWardsRequest
  | SearchWardsSuccess
  | SearchWardsFailure
  | DetectWardByCoordinateRequest
  | DetectWardByCoordinateSuccess
  | DetectWardByCoordinateFailure
  | FetchSearchTypesRequest
  | FetchSearchTypesSuccess
  | FetchSearchTypesFailure
  | FetchWardsRequest
  | FetchWardsSuccess
  | FetchWardsFailure
  | SetDefaultData
  | FetchDiscountGroupsRequest
  | FetchDiscountGroupsSuccess
  | FetchDiscountGroupsFailure
  | FetchAssessableTypesRequest
  | FetchAssessableTypesSuccess
  | FetchAssessableTypesFailure
  | FetchBusinessSubcategoryTypeRequest
  | FetchBusinessSubcategoryTypeSuccess
  | FetchBusinessSubcategoryTypeFailure
  | FetchBusinessSubcategoryCalculationTypeRequest
  | FetchBusinessSubcategoryCalculationTypeSuccess
  | FetchBusinessSubcategoryCalculationTypeFailure
  | ExportListDataRequest
  | ExportListDataSuccess
  | ExportListDataFailure
  | FetchPropertyStatusesRequest
  | FetchPropertyStatusesSuccess
  | FetchPropertyStatusesFailure
  | FetchActiveLayersRequest
  | FetchActiveLayersSuccess
  | FetchActiveLayersFailure
  | DetectLayerRequest
  | DetectLayerSuccess
  | DetectLayerFailure
  | DetectAllLayersRequest
  | DetectAllLayersSuccess
  | DetectAllLayersFailure
  | FetchOrganizationsRequest
  | FetchOrganizationsSuccess
  | FetchOrganizationsFailure
  | FetchBusinessCategoriesRequest
  | FetchBusinessCategoriesSuccess
  | FetchBusinessCategoriesFailure
  | FetchContactsRequest
  | FetchContactsSuccess
  | FetchContactsFailure
  | FetchContactTitlesRequest
  | FetchContactTitlesSuccess
  | FetchContactTitlesFailure
  | FetchFormsRequest
  | FetchFormsSuccess
  | FetchFormsFailure
  | FetchLayerFeaturesRequest
  | FetchLayerFeaturesSuccess
  | FetchLayerFeaturesFailure
  | FetchStaticTemplateRequest
  | FetchStaticTemplateSuccess
  | FetchStaticTemplateFailure
  | AcceptTermsOfServiceRequest
  | AcceptTermsOfServiceSuccess
  | AcceptTermsOfServiceFailure
  | FetchMobileTaskTypesRequest
  | FetchMobileTaskTypesSuccess
  | FetchMobileTaskTypesFailure
  | FetchTemplateTypesRequest
  | FetchTemplateTypesSuccess
  | FetchTemplateTypesFailure
  | FetchAreaRoundingRequest
  | FetchAreaRoundingSuccess
  | FetchAreaRoundingFailure
  | FetchAuditLogTypesRequest
  | FetchAuditLogTypesSuccess
  | FetchAuditLogTypesFailure
  | FetchPropertyTypesByCodeRequest
  | FetchPropertyTypesByCodeSuccess
  | FetchPropertyTypesByCodeFailure
  | FetchLicenseTypesRequest
  | FetchLicenseTypesSuccess
  | FetchLicenseTypesFailure
  | FetchPropertyTypesRequest
  | FetchPropertyTypesSuccess
  | FetchPropertyTypesFailure
  | FetchMobileUserModesRequest
  | FetchMobileUserModesSuccess
  | FetchMobileUserModesFailure
  | FetchPostprocessorSlotTypesRequest
  | FetchPostprocessorSlotTypesSuccess
  | FetchPostprocessorSlotTypesFailure
  | FetchDocumentTypesRequest
  | FetchDocumentTypesSuccess
  | FetchDocumentTypesFailure
